import axios from "axios";
import React from "react";
import {useMap} from "react-map-gl";
import {useRecoilValue} from "recoil";

import {selectedFocusAreaAtom} from "../../../map/selectedRegionAtoms"
import {gis2TokenAtom} from '../../../login/loginAtoms.js'

import {gis2QueryUrl} from "../../../utils/urls";

export default function CatchmentAreaLayerUpdater() {
    const mapRef = useMap()
 	const gis2Token = useRecoilValue(gis2TokenAtom)
    const selectedFocusArea = useRecoilValue(selectedFocusAreaAtom)

    React.useEffect(() => {
        if (!mapRef.map) {
            return
        }

        if (!gis2Token) {
            return
        }

        if (!selectedFocusArea || !selectedFocusArea.properties.layer || !selectedFocusArea.properties.id) {
            return
        }

        const map = mapRef.map

        const url = gis2QueryUrl(
            "hsds_experian_shoppoint",
            6,
            {
                where: `layer='${selectedFocusArea.properties.layer}' and id=${selectedFocusArea.properties.id}`,
                token: gis2Token
            }
        );

        axios.get(url).then(response => {
            console.log(response.data);
            map.getSource('catchment-area').setData(response.data)
        })
    }, [gis2Token, mapRef.map, selectedFocusArea]);

    // return null as there is nothing to render: this component just exists to apply a useEffect hook to update the catchment areas
    return null;
}